const partners = [
  { name: '香港交易所', type: 'exchange' },
  { name: '中信证券国际', type: 'securities' },
  { name: '高盛亚洲', type: 'investment' },
  { name: '摩根士丹利', type: 'investment' },
  { name: '普华永道', type: 'advisory' },
  { name: '金杜律师事务所', type: 'legal' },
  { name: '汇丰银行', type: 'banking' },
  { name: '渣打银行', type: 'banking' },
];

export default function Partners() {
  return (
    <section className="py-20 md:py-24 bg-background-50">
      <div className="px-6 md:px-12 lg:px-20">
        <div className="max-w-[1400px] mx-auto">
          {/* Section header */}
          <div className="text-center mb-14">
            <p className="text-xs md:text-sm font-semibold tracking-[0.25em] uppercase text-accent-500 mb-3">Ecosystem Partners</p>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-100">全球合作生态</h2>
            <p className="mt-3 text-sm text-foreground-500 max-w-xl mx-auto">
              与全球顶尖金融机构与专业服务机构建立深度合作
            </p>
          </div>

          {/* Partner logos grid */}
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-5">
            {partners.map((partner) => (
              <div
                key={partner.name}
                className="group flex items-center justify-center h-22 md:h-24 px-4 rounded-xl bg-background-100 border border-background-300/30 hover:border-accent-500/30 hover:bg-background-200/50 transition-all duration-300"
              >
                <div className="text-center">
                  <div className="w-10 h-10 mx-auto mb-2 rounded-lg bg-background-200/60 border border-background-300/30 group-hover:border-accent-500/25 group-hover:bg-accent-500/8 flex items-center justify-center transition-all duration-300">
                    <i className="ri-bank-line text-lg text-foreground-500 group-hover:text-accent-400 transition-colors duration-300"></i>
                  </div>
                  <p className="text-xs md:text-sm font-medium text-foreground-400 group-hover:text-foreground-200 transition-colors duration-200 whitespace-nowrap">
                    {partner.name}
                  </p>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-10">
            <p className="text-[10px] text-foreground-600">
              * 以上为部分合作伙伴，排名不分先后
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}